<template>
  <div class="GolfMemberShip">
    <div class="homepage">
      <h2 class="Orangetitle">{{acf.acf.golfpark_title}}</h2>
      <p class="blackStandard-text golfParkText-width" v-html="acf.acf.golfpark_blog"></p>
      <b-link :to="'/contact'">
        <b-button class="golfMemberBtn" variant="">Get in Touch Today</b-button>
      </b-link>

      <!-- <b-row class="container bannersec">
        <b-col>
            <b-link to="/contact">
                <template  v-if="isMobile(true)">
                    <img class="banner" src="https://wp-ocssport.ocs-sport.com/golfpark/wp-content/uploads/sites/4/2025/05/mob1.jpg">
                </template>
                <template v-else>
                    <img class="banner" src="https://wp-ocssport.ocs-sport.com/golfpark/wp-content/uploads/sites/4/2025/05/1.jpg">
                </template>
            </b-link>
        </b-col>
      </b-row> -->

      <!-- desktop  -->
      <b-row class="membership-Options container above1400">
        <b-col lg="4" sm="12" class="golfBoxes">
            <div class="borderMemberShip">
                <h2 class="blacktitle">{{acf.acf.golfpark_option_three}} <span class="sideText">{{acf.acf.golfpark_option_three_span}}</span></h2>
                <h3 class="Membership-Prices">{{acf.acf.golfpark_option_three_price}}<span class="perMonth"> {{acf.acf.golfpark_option_three_price_extra}}</span></h3>
                <ul class="MemberBullet-Points MBP-desktop">
                    <li v-for="(optionone, index) in acf.acf.golfpark_option_three_list" :key="index">{{optionone.golf_park_membership_list_three}}</li>
                    <!-- <li>Allows for up to 4 players per session</li> -->
                </ul>
                <div class="memberEnquiry">
                    <b-link :href="'https://apps.apple.com/gb/app/sim-park/id6738054804'" target="_blank">
                        <b-button class="MemberBtn">Download the App</b-button>
                    </b-link>
                </div>
            </div>
        </b-col>
        <b-col lg="4" sm="12" class="golfBoxes">
            <div class="borderMemberShip">
                <h2 class="blacktitle">{{acf.acf.golfpark_option_two}} <span class="sideText">{{acf.acf.golfpark_option_two_span}}</span></h2>
                <h3 class="Membership-Prices">{{acf.acf.golfpark_option_two_price}}<span class="perMonth">{{acf.acf.golfpark_option_two_price_extra}}</span></h3>
                <ul class="MemberBullet-Points">
                    <li v-for="(optiontwo, index) in acf.acf.golfpark_option_two_list" :key="index">{{optiontwo.golf_park_membership_list_two}}</li>
                    <!-- <li>Allows for up to 4 players per session</li> -->
                </ul>
                <div class="memberEnquiry">
                    <b-link :to="'/contact'">
                        <b-button class="MemberBtn">Get in Touch Today</b-button>
                    </b-link>
                </div>
            </div>
        </b-col>
        <b-col lg="4" sm="12" class="golfBoxes">
            <div class="borderMemberShip">
                <h2 class="blacktitle">{{acf.acf.golfpark_option_one}} <span class="sideText">{{acf.acf.golfpark_option_one_span}}</span></h2>
                <h3 class="Membership-Prices">{{acf.acf.golfpark_option_one_price}}<span class="perMonth">{{acf.acf.golfpark_option_one_price_extra}}</span></h3>
                <ul class="MemberBullet-Points">
                    <li v-for="(optionone, index) in acf.acf.golfpark_option_one_list" :key="index">{{optionone.golf_park_membership_list_one}}</li>
                    <!-- <li>Allows for up to 4 players per session</li> -->
                </ul>
                <div class="memberEnquiry">
                    <b-link :to="'/contact'">
                        <b-button class="MemberBtn">Get in Touch Today</b-button>
                    </b-link>
                </div>
            </div>
        </b-col>
      </b-row>
      <!-- mobile  -->
      <b-row class="membership-Options container below1400">
        <b-col lg="12" sm="12" class="PandP">
            <div class="borderMemberShip PayandPlay">
                <h2 class="blacktitle">{{acf.acf.golfpark_option_three}} <span class="sideText">{{acf.acf.golfpark_option_three_span}}</span></h2>
                <h3 class="Membership-Prices">{{acf.acf.golfpark_option_three_price}}<span class="perMonth"> {{acf.acf.golfpark_option_three_price_extra}}</span></h3>
                <ul class="MemberBullet-Points MBP-desktop">
                    <li v-for="(optionone, index) in acf.acf.golfpark_option_three_list" :key="index">{{optionone.golf_park_membership_list_three}}</li>
                    <!-- <li>Allows for up to 4 players per session</li> -->
                </ul>
                <div class="memberEnquiry">
                    <b-link :href="'https://apps.apple.com/gb/app/sim-park/id6738054804'" target="_blank">
                        <b-button class="MemberBtn">Download the App</b-button>
                    </b-link>
                </div>
            </div>
        </b-col>
        <b-col lg="6" sm="12" >
            <div class="borderMemberShip">
                <h2 class="blacktitle">{{acf.acf.golfpark_option_two}} <span class="sideText">{{acf.acf.golfpark_option_two_span}}</span></h2>
                <h3 class="Membership-Prices">{{acf.acf.golfpark_option_two_price}}<span class="perMonth"> {{acf.acf.golfpark_option_two_price_extra}}</span></h3>
                <ul class="MemberBullet-Points">
                    <li v-for="(optiontwo, index) in acf.acf.golfpark_option_two_list" :key="index">{{optiontwo.golf_park_membership_list_two}}</li>
                    <!-- <li>Allows for up to 4 players per session</li> -->
                </ul>
                <div class="memberEnquiry">
                    <b-link :to="'/contact'">
                        <b-button class="MemberBtn">Get in Touch Today</b-button>
                    </b-link>
                </div>
            </div>
        </b-col>
        <b-col lg="6" sm="12">
            <div class="borderMemberShip">
                <h2 class="blacktitle">{{acf.acf.golfpark_option_one}} <span class="sideText">{{acf.acf.golfpark_option_one_span}}</span></h2>
                <h3 class="Membership-Prices">{{acf.acf.golfpark_option_one_price}}<span class="perMonth"> {{acf.acf.golfpark_option_one_price_extra}}</span></h3>
                <ul class="MemberBullet-Points">
                    <li v-for="(optionone, index) in acf.acf.golfpark_option_one_list" :key="index">{{optionone.golf_park_membership_list_one}}</li>
                    <!-- <li>Allows for up to 4 players per session</li> -->
                </ul>
                <div class="memberEnquiry">
                    <b-link :to="'/contact'">
                        <b-button class="MemberBtn">Get in Touch Today</b-button>
                    </b-link>
                </div>
            </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'Golf Park Memberships',
  components: {

  },
  data: function() {
    return {
      acf: [],
    };
  },
  methods: {
    isMobile() {
        if( screen.width <= 500 ) {
            return true;
        }
        else {
            return false;
        }
    },
  },
  mounted() {
    axios //add API Call
        .get(
           process.env.VUE_APP_API_URL + 'golfpark' + "/wp-json/wp/v2/pages/25" + '?randomadd=' +
          new Date().getTime()
        ) // Page number changed on each page based on JSON page id you are calling
        .then((response) => (
            this.acf = response.data
        )); //API data wanted pulled out
  },
}
</script>

<style scoped>
.bannersec {
    display: block;
    margin: auto;
    padding-bottom: 60px;
}
.banner {
    width: 100%;
}
span.sideText {
    font-size: 32px;
    display: block;
}
button.MemberBtn {
    background-color: #FF8B17;
    border-color: #FF8B17!important;
    border-radius: 50px;
    width: 163px;
    height: 31px;
    line-height: 1;
    color: #fff;
    font-size: 18px;
    font-weight: bold;
    width: 100%;
    height: 54px;
    font-family: "noto-sans", sans-serif;
    /* height: 35px; */
}
button.MemberBtn:hover {
    background-color: #707070;
    border-color: #707070!important;
    color: #fff;
}
.memberEnquiry {
    position: absolute;
    width: 100%;
    padding-left: 15px;
    padding-right: 50px;
    bottom: 35px;
}
.Orangetitle {
    color: #FF8B17;
    font-size: 40px;
    font-family: "korolev", sans-serif;
    font-weight: 700;
    font-style: italic;
}
.blacktitle {
    color: #11182F;
    /* font-size: 40px; */
    font-size: 32px;
    font-family: "korolev", sans-serif;
    font-weight: 700;
    font-style: italic;
}
.GolfMemberShip {
    padding: 50px;
}
.blackStandard-text {
    font-size: 24px;
    color: #11182F;
    font-family: "noto-sans", sans-serif;
    font-weight: 400;
    font-style: normal;
}
.golfParkText-width {
    width: 70%;
    text-align: center;
    margin: auto;
    padding-top: 30px;
    padding-bottom: 30px;
}
button.golfMemberBtn {
    background-color: #1A1A1A;
    border-color: #1A1A1A!important;
    border-radius: 50px;
    width: 163px;
    height: 31px;
    line-height: 1;
    color: #fff;
    font-size: 18px;
    font-weight: bold;
    width: 535px;
    height: 54px;
    margin-top: 25px;
    margin-bottom: 50px;
    font-family: "noto-sans", sans-serif;
}
button.golfMemberBtn:hover {
    background-color: #707070;
    border-color: #707070!important;
    color: #fff;
}
.membership-Options {
    margin-top: 60px;
    margin: auto;
}
h3.Membership-Prices {
    color: #FF8B17;
    font-size: 29px;
    padding-top: 5px;
    font-family: "noto-sans", sans-serif;
    font-weight: 700;
    font-style: normal;
}
.perMonth {
    color: #FF8B17;
    font-size: 15px;
    font-weight: bold;
}
.borderMemberShip {
    border: 1px solid #11182F;
    padding-top: 40px;
    padding-bottom: 120px;
    /* height: 400px; */
    /* height: 1000px; */
    /* height: 1200px; */
    /* height: 1100px; */
    /* min-height: 900px; */
    flex: 1;
}
.golfBoxes.col-sm-12.col-lg-4 {
    display: flex;
}
ul.MemberBullet-Points {
    color: #11182F;
    font-size: 22px;
    text-align: left;
    list-style-type: circle;
    margin-top: 50px;
    font-family: "noto-sans", sans-serif;
    font-weight: 400;
    font-style: normal;
    padding-right: 50px;
    padding-left: 58px;
}
ul.MemberBullet-Points > li {
    padding-bottom: 10px;
}

/* MobileCSS */
@media only screen and (min-width: 1401px) {
    .below1400 {
        display: none;
    }
}
@media only screen and (max-width: 1400px) {
    .above1400 {
        display: none;
    }
    .PayandPlay {
        height: 600px;
    }
    .blacktitle {
        color: #11182F;
        font-size: 32px;
        font-family: "korolev", sans-serif;
        font-weight: 700;
        font-style: italic;
        padding-left: 20px;
        padding-right: 20px;
    }
    .PandP {
        margin-bottom: 30px;
    }
}
@media only screen and (min-width: 1200px) {
    ul.MemberBullet-Points.MBP-desktop {
        /* margin-top: 97px;  */
        margin-top: 50px; 
    }
}
@media only screen and (max-width: 1024px) {
    .PayandPlay {
        height: 540px!important;
    }
}
@media only screen and (max-width: 990px) {
    .borderMemberShip {
        height: 1100px;
        margin-bottom: 20px;
    }
    .memberEnquiry {
        position: absolute;
        width: 100%;
        padding-left: 15px;
        padding-right: 50px;
        bottom: 45px;
    }
}
@media only screen and (max-width: 768px) {
    h3.Membership-Prices {
        font-size: 20px;
    }
    .blacktitle {
        font-size: 32px;
    }
    .blackStandard-text {
        font-size: 20px;
        color: #11182F;
        font-family: "noto-sans", sans-serif;
        font-weight: 400;
        font-style: normal;
    }
    .Orangetitle {
        font-size: 36px;
    }
    .GolfMemberShip {
        padding: 25px;
    }
    .container {
        padding-left: 0;
        padding-right: 0;
    }
    button.golfMemberBtn {
        background-color: #1A1A1A;
        border-color: #1A1A1A!important;
        border-radius: 50px;
        width: 163px;
        height: 31px;
        line-height: 1;
        color: #fff;
        font-size: 20px;
        font-weight: bold;
        width: 100%;
        height: 54px;
        margin-top: 25px;
    }
    button.golfMemberBtn:hover {
        background-color: #FF8B17;
        border-color: #FF8B17!important;
        color: #fff;
    }
    .golfParkText-width {
        width: 100%; 
        text-align: center;
        margin: auto;
        padding-top: 30px;
        padding-bottom: 30px;
    }
    .borderMemberShip {
        /* height: auto!important; */
        margin-bottom: 20px;
    }
    ul.MemberBullet-Points {
        padding-left: 30px; 
        font-size: 20px;
        padding-bottom: 30px;
    }
    .memberEnquiry {
        bottom: 35px;
    }
}
@media only screen and (max-width: 500px) {
    ul.MemberBullet-Points {
        padding-left: 30px;
        font-size: 18px;
        padding-bottom: 30px;
    }
    .borderMemberShip {
        height: auto !important;
        margin-bottom: 20px;
    }
}
</style>
